<template>
    <v-card flat>
        <v-card-title>
            <span class="ml-3 text-h6 font-weight-bold">Order Summary</span>
        </v-card-title>
        <v-card-text>
            <v-list v-if="type==2">
                <template v-for="item in order.items">
                    <v-list-item :key="item._id" class="my-2">
                        <v-list-item-icon>
                            <v-img :src="`${item?.image?.path ? host+item.image.path : defaultProductImage}`" width="50" height="50"></v-img>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-subtitle>{{ item.title }}</v-list-item-subtitle>
                            <!-- <label class="grey--text">Qty: {{ item.quantity }}</label> -->
                            <label class="grey--text"><v-icon size="small">mdi-currency-inr</v-icon>{{ item.price }} x {{ item.quantity }}</label>
                        </v-list-item-content>
                        <v-list-item-action>
                            <span class="text-subheading-1"><v-icon size="small">mdi-currency-inr</v-icon>{{item.amount}}</span>
                        </v-list-item-action>
                        <!-- {{ item }} -->
                    </v-list-item>
                </template>
            </v-list>
            <v-divider></v-divider>
            <v-list>
                <v-list-item v-if="hasModuleAccess('coupon') && ($store.getters.vendor.enableBothRewardType || !$store.getters.vendor.enableBothRewardType && order.redeemedReward == 0)">
                    <coupon :order="order" style="width: 100%" v-model="order.discount.code" @setAmount="$event => order.discount.amount = $event"
                        @clear="$event => order.discount.amount = 0" />
                </v-list-item>
                <v-list-item>
                    <v-list-item-title class="grey--text">Subtotal</v-list-item-title>
                    <v-list-item-title class="text-right"><v-icon size="medium">mdi-currency-inr</v-icon>{{
                        this.order?.subTotal }}</v-list-item-title>
                </v-list-item>
                <v-list-item v-if="order.delivery.type.code == 'home-delivery'">
                    <v-list-item-title class="grey--text">Shipping</v-list-item-title>
                    <v-list-item-title class="text-right"><v-icon size="medium">mdi-currency-inr</v-icon>{{
                        this.order?.delivery?.charge }}</v-list-item-title>
                </v-list-item>
                <v-list-item v-if="order.discount.amount > 0">
                    <v-list-item-title class="green--text">Discount</v-list-item-title>
                    <v-list-item-title class="text-right green--text"><v-icon size="medium" class="green--text">mdi-currency-inr</v-icon>{{
                        this.order?.discount?.amount }}</v-list-item-title>
                </v-list-item>
                <v-list-item v-if="order.taxAmount">
                    <v-list-item-title class="grey--text">Taxes</v-list-item-title>
                    <v-list-item-title class="text-right"><v-icon size="medium">mdi-currency-inr</v-icon>{{
                        this.order?.taxAmount }}</v-list-item-title>
                </v-list-item>
                <v-divider></v-divider>
                <v-list-item>
                    <v-list-item-title class="text-subtitle-1 font-weight-bold">Order Total</v-list-item-title>
                    <v-list-item-title class="text-right"><v-icon size="medium">mdi-currency-inr</v-icon>{{
                        this.order?.total | amountFormat }}</v-list-item-title>
                </v-list-item>
                <v-divider></v-divider>
                <v-list-item v-if="order.delivery.type.code == 'home-delivery'">
                    <v-list-item-title class="font-weight-bold">Estimated Delivery</v-list-item-title>
                    <v-list-item-title class="text-right"><v-icon size="medium">mdi-date</v-icon>{{
                        this.order?.delivery.date }}</v-list-item-title>
                </v-list-item>
            </v-list>
            <!-- {{ order.customer }} -->
            <v-btn block :style="theme" to="checkout" text v-if="type==1">Proceed to Checkout</v-btn>
            <v-btn block :style="theme" text v-if="type==2" @click="placeOrder()">Place Order</v-btn>
        </v-card-text>
    </v-card>
</template>

<script>
import BillingFunction from '../mixins/billingFunction.js'
import appConstants from '../utils/appConstants.js'
import Coupon from './Coupon.vue'
export default {
  components: { Coupon },
    mixins: [BillingFunction],
    props: {
        type: {
            type: Number,
            default: () => 1
        }
    },
    computed: {
        order() {
            this.calculateTotal(this.$store.getters.order)
            return this.$store.getters.order
        }
    },
    methods: {
        async placeOrder() {
            if(_.isEmpty(this.order.customer.mobileNo) || _.isEmpty(this.order.customer.firstName) || _.isEmpty(this.order.customer.lastName)){
                alert("Please Provide Customer Details")
                return
            }
                
            if (this.order.delivery.type.code == 'home-delivery' && !this.order.delivery.address){
                alert("Please Provide Shipping Address")
                return
            }
            else if (this.order.delivery.type.code == 'pick-up-from-shop' && !this.order.delivery.pickupPoint && this.$store.getters.vendor.pickupPoints.length > 0){
                alert("Please Select a Pickup point")
                return
            }
            this.order.pStatus = this.paymentStatus.COD
            this.order.customer.vendorId = this.$store.getters.vendor._id
            let savedOrder = await this.postItem(appConstants.SIGNUP_FREE_ORDER, this.order)
            this.orderAlert(savedOrder)
        },
        orderAlert(savedOrder) {
            if (savedOrder) {
                alert(`Congratulations!! Your Order Placed successfully\nYour order number is ${savedOrder.orderNo}.\nSoon you will receive confirmation call from ${this.$store.getters.vendor.businessName}`)
                this.$store.dispatch("actionUpdateCart", [])
                this.$router.push("/store")
            }
        }
    },
}
</script>

<style lang="scss" scoped></style>